/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';
import { ACCESS_ASSETS_ENDPOINTS } from './lais/endpoints';

const idempotencyKey = payload =>
  payload?.idempotency_key || payload?.idempotencyKey;

const configWithIdempotency = payload => {
  const config = requestConfig();
  const key = idempotencyKey(payload);
  if (key) {
    config.headers['X-Idempotency-Key'] = key;
  }
  return config;
};

const writePayload = payload => {
  const nextPayload = { ...payload };
  delete nextPayload.idempotencyKey;
  nextPayload.idempotency_key = idempotencyKey(payload);
  return nextPayload;
};

class AccessAssetsAPI extends ApiClient {
  constructor() {
    super('access_assets', { accountScoped: true });
  }

  get accountUrl() {
    return this.url.replace(/\/access_assets$/, '');
  }

  get(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  forImovel(imovelId, params = {}) {
    return axios.get(
      withQuery(
        resourcePath(this.accountUrl, 'imoveis', imovelId, 'access_assets'),
        params
      ),
      requestConfig()
    );
  }

  show(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  createForImovel(imovelId, payload = {}) {
    return axios.post(
      resourcePath(this.accountUrl, 'imoveis', imovelId, 'access_assets'),
      { idempotency_key: idempotencyKey(payload), access_asset: payload },
      configWithIdempotency(payload)
    );
  }

  timeline(id, params = {}) {
    return axios.get(
      withQuery(
        resourcePath(this.url, id, ACCESS_ASSETS_ENDPOINTS.timeline),
        params
      ),
      requestConfig()
    );
  }

  block(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, ACCESS_ASSETS_ENDPOINTS.block),
      writePayload(payload),
      configWithIdempotency(payload)
    );
  }

  unblock(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, ACCESS_ASSETS_ENDPOINTS.unblock),
      writePayload(payload),
      configWithIdempotency(payload)
    );
  }

  reserve(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, ACCESS_ASSETS_ENDPOINTS.reserve),
      writePayload(payload),
      configWithIdempotency(payload)
    );
  }
}

export default new AccessAssetsAPI();
